import { type ErrorResponse, isRouteErrorResponse, useRouteError } from 'react-router'

import { FallbackAppLayout } from 'apps/employer_dashboard/components/FallbackAppLayout'
import { ErrorBoundaryInfo } from 'shared/dashboard/ErrorBoundaryInfo'

function getHeadingForStatus (error: ErrorResponse) {
  switch (error.status) {
    case 401:
      return 'Not authorized'
    case 404:
      return 'Page not found'
    default:
      return 'We could not load the dashboard'
  }
}

function getMessageForStatus (error: ErrorResponse) {
  switch (error.status) {
    case 401:
      return 'You are not authorized to access this page'
    case 404:
      return "The page you requested doesn't exist. If you keep running into trouble, send us an email at support@thatch.com."
    default:
      return error.statusText ?? 'Something unexpected happened. We have been notified and are looking into it.'
  }
}

export function RootErrorPage () {
  const error = useRouteError()

  function renderError () {
    if (isRouteErrorResponse(error)) {
      const debugInfo = error.data.requestId
        ? { 'Request ID': error.data.requestId }
        : undefined

      return (
        <ErrorBoundaryInfo
          debugInfo={debugInfo}
          heading={getHeadingForStatus(error)}
          message={getMessageForStatus(error)}
          status={error.status}
        />
      )
    }

    return (
      <ErrorBoundaryInfo
        heading='We could not render the dashboard because of an unexpected error'
        message='Our team has been notified and is looking into it'
      />
    )
  }

  return (
    <FallbackAppLayout>
      <div className='grow flex flex-col items-center justify-center'>
        {renderError()}
      </div>
    </FallbackAppLayout>
  )
}
